$(document).ready(function () {
    $(document).on('click', '[data-cart-item-add-button]', function (e) {
        e.preventDefault();
        // console.log('HELLLO')
        const productHandle = $(this).attr('data-item-handle');
        // console.log('productHandle',productHandle)
        $('body').addClass('cart-item-popup-open-body');
        $('.cart-item-popup-modal[data-item-handle="' + productHandle + '"]').addClass('cart-item-popup-open');

        // Get Variant Details
        // const variantContainer = $(this).closest('.cart__item--right').find('.cart-child-items-wrapper');
        // variantContainer.find('.product-option').each(function() {
        //     const optionValue = $(this).find('dd').text().trim();
        //     $('.cart-item-popup-modal[data-item-handle="' + productHandle + '"]').find(".cart-item-popup-size-radio-input[data-variant-title='"+optionValue+"']").addClass("in-cart-selected");
        //     $('.cart-item-popup-modal[data-item-handle="' + productHandle + '"]').find(".cart-item-popup-size-radio-input[data-variant-title='"+optionValue+"']").closest('.cart-item-popup-size-main').addClass("in-cart-selected-parent");
        //     $('.cart-item-popup-modal[data-item-handle="' + productHandle + '"]').find('input[type="radio"]:not(:disabled):not(.in-cart-selected)').first().trigger("click");
        // });

        const cartItemPopupModal = $('.cart-item-popup-modal[data-item-handle="' + productHandle + '"]');
        const variantContainer = $(this).closest('.cart__item--right').find('.cart-child-items-wrapper');
        variantContainer.find('.product-option').each(function() {
            const optionValue = $(this).find('dd').text().trim();
            const radioInput = cartItemPopupModal.find(".cart-item-popup-size-radio-input[data-variant-title='" + optionValue + "']");
            radioInput.addClass("in-cart-selected").closest('.cart-item-popup-size-main').addClass("in-cart-selected-parent");
            cartItemPopupModal.find('input[type="radio"]:not(:disabled):not(.in-cart-selected)').first().trigger("click");
        });
    });
    $(document).on('click', '.cart-item-popup-modal-close, .modal-backdrop, [data-popup-item-cancel]', function () {
        $('body').removeClass('cart-item-popup-open-body');
        $('.cart-item-popup-modal').removeClass('cart-item-popup-open');
    });

    $(document).on('change', '.cart-item-popup-size-main input[type="radio"]', function () {
        // console.log($(this).val());
    });

    $(document).on('click', '[data-popup-item-add]', function (e) {
        e.preventDefault();
        const __this = $(this);
        $(this).addClass('loading');
        $(this).addClass('disabled');
        $(this).closest('.cart-item-popup-modal').find('[data-popup-item-cancel]').addClass('disabled');
        const variantID = $(this).closest('.cart-item-popup-modal').find('input[type="radio"]:checked').val();
        const productSku = $(this).closest('.cart-item-popup-modal').find('input[type="radio"]:checked').data('variant-sku');
        const productJobID = $(this).closest('.cart-item-popup-modal').data('item-jobs-id');
        const dataAppHandle = $('body').data('shop-handle');
        console.log('dataAppHandle', dataAppHandle);
        console.log('variantID', variantID);
        console.log('productSku', productSku);
        console.log('productJobID', productJobID);
        console.log('API CALL => https://{REPLACE}/api/pulse-app/addProductVariant',dataAppHandle);
        $.ajax({
            url: `https://${dataAppHandle}/api/pulse-app/addProductVariant`,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                variantId: variantID,
                sku: String(productSku),
                jobs_id: productJobID,
                quantity: 1
            }),
            success: function (response) {
                console.log('Success:', response);
                // var successItemIds = response.items.map(function (item) {
                //     return item.id;
                // });
                // addSuccessItems(successItemIds);
                const successItems = response
                addSuccessItems(successItems);
            },
            error: function (xhr, status, error) {
                console.error('Error:', error);
                __this.removeClass('loading');
                __this.removeClass('disabled');
                __this.closest('.cart-item-popup-modal').find('[data-popup-item-cancel]').removeClass('disabled');
                __this.closest('.cart-item-popup-modal').find('.error-msg').html('Something went wrong. Try again in a few minutes')
                setTimeout(function(){
                    $('.error-msg').html('');
                },5000);
            }
        });

        function addSuccessItems(successItems) {
            console.log('successItems:', successItems);
            let formData = successItems;
            console.log('formData',formData)
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    updateCart()
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    });


    // BULK REMOVE
    $(document).on('click', '.cart-bulk-remove-button', function (e) {
        e.preventDefault();
        const __this = $(this);
        __this.closest('.cart__item-right--info').find('.loading__spinner').removeClass('hidden');
        const itemsIDArray = $(this).attr('data-items-ids').split(',');
        console.log('itemsIDArray', itemsIDArray);
        const currentLocation = $(location).attr('href');
        let updates = {};
        itemsIDArray.forEach(function(itemId) {
            itemId = itemId.trim();
            if (itemId) {
                updates[itemId] = 0;
            }
        });
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
            __this.closest('.cart__item-right--info').find('.loading__spinner').addClass('hidden');
            updateCart();
            setTimeout(function(){
                if (currentLocation.includes('/cart')) {
                    console.log('LOCATION IS CART');
                    window.location.reload();
                }
            }, 1000);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });

    function updateCart() {
        fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
            const cartid = 'CartDrawer';
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.querySelector('#CartDrawer');
            const source = html.getElementById(cartid);
            if (source && destination) destination.innerHTML = source.innerHTML;
            $.ajax({
                url: '/?section_id=cart-icon-bubble',
                type: 'GET',
                dataType: 'html',
                success: function (itemcount) {
                    $("#cart-icon-bubble").html($(itemcount).html());
                    // $(".cart-count-bubble").trigger("click");
                    console.log('cart updated');
                    $('[data-popup-item-add]').removeClass('loading');
                    $('[data-popup-item-add]').removeClass('disabled');
                    $('[data-popup-item-cancel]').removeClass('disabled');
                    $("[data-popup-item-cancel]").trigger("click");
                    
                    if (typeof collectionSlider === 'function') {
                        collectionSlider('.cart_drawer--collection-box--wrapper');
                    }
                    if (typeof initCartDrawerSlider === 'function') {
                        setTimeout(initCartDrawerSlider, 200); 
                    }
                }
            });
        });
    }

    // APPROVAL CHECKBOX
    const approvalLabelValue = $('#approval_checkbox').is(":checked") ? $('#approval_checkbox').val() : "";
    updateCartAttributes(approvalLabelValue)
    $(document).on('change', '#approval_checkbox', function (e) {
        e.preventDefault();
        const approvalLabel = $(this).is(":checked") ? $(this).val() : "";
        updateCartAttributes(approvalLabel)
    });
    function updateCartAttributes(approvalLabel) {
        fetch('/cart/update.js', {
            method: "POST",
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json;'
            },
            body: JSON.stringify({
                attributes: {
                    Approval: approvalLabel
                }
            })
        });
    }

    // APPROVAL POPUP
    $(document).ready(function () {
      var isB2B = $('body').data('b2b-customer');
      if (isB2B === false || isB2B === "false") {
        console.log('NOT B2B CUSTOMER - SHOW APPROVAL POPUP');
        $(document).on('click', '#CartDrawer-Checkout', function (e) {
            e.preventDefault();

            const totalHats = $(this).attr('data-total-hats');
            if(totalHats !== undefined){
                let totalHatsAttribute = false;
                if(parseInt(totalHats) > 50) {
                    totalHatsAttribute = true;
                }
                console.log('totalHats',totalHats);
                fetch('/cart/update.js', {
                    method: "POST",
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json;'
                    },
                    body: JSON.stringify({
                        attributes: {
                            _MoreThan50Hats: totalHatsAttribute
                        }
                    })
                });
            }
            
            const CheckoutButton = $('#CartDrawer-Checkout').attr("data-patch-in-cart");
            if (CheckoutButton === 'true') {
                $('.cart-approval-popup-modal-dialog').addClass("patch-in-cart");
            } else {    
                $('.cart-approval-popup-modal-dialog').removeClass("patch-in-cart");
            }


            $('body').addClass('approval-open');
            $('.cart-approval-popup-btn-wrapper').addClass('loading');
            setTimeout(function() {
                $('.cart-approval-popup-btn-wrapper').removeClass('loading');
            },2000);
        });
        $(document).on('click', '.approval-cancel-btn', function (e) {
            e.preventDefault();
            $('body').removeClass('approval-open');
        });
        $(document).on('click', '.approval-accept-btn', function (e) {
            e.preventDefault();
            window.location.href = "/checkout";
        });
        }
    });

    // REMOVE JUMP THE LINE
    $(document).on('click', '[data-jump-the-line-remove]', function (e) {
        e.preventDefault();
        $(this).addClass('disabled');
        const jumpItemID = $(this).attr('data-item-id');
        $('.cart-remove-button[data-variant-id="'+jumpItemID+'"]').trigger('click');
        setTimeout(function(){
            $(this).removeClass('disabled');
        },5000);
    });

    // ADD JUMP THE LINE
    $(document).on('click', '[data-jump-the-line-add]', function (e) {
        e.preventDefault();
        $(this).addClass('disabled loading');
        const jumpItemID = $(this).attr('data-item-id');
        let formData = {
            items: [{
                id: jumpItemID,
                quantity: 1
            }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
        .then(response => {
            updateCart();
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
            $(this).removeClass('disabled loading');
        });
    });
});